import { gql } from '@apollo/client';

export default gql`
  mutation createDocEntry(
    $branch: String
    $opType: Int
    $title: String
    $desc: String
    $items: String
    $contractId: String
    $contractName: String
    $contractNameAr: String
    $customerId: String
    $customerName: String
    $customerNameAr: String
    $supplierId: String
    $supplierName: String
    $supplierNameAr: String
    $departmentId: String
    $departmentName: String
    $departmentNameAr: String
    $employeeId: String
    $employeeName: String
    $employeeNameAr: String
    $employeeColor: String
    $resourseId: String
    $resourseName: String
    $resourseNameAr: String
    $resourseColor: String
    $total: Float
    $discount: Float
    $amount: Float
    $debit: Float
    $debitAcc: Int
    $debitAccName: String
    $debitAccNameAr: String
    $credit: Float
    $creditAcc: Int
    $creditAccName: String
    $creditAccNameAr: String
    $chequeBank: String
    $chequeNo: String
    $chequeDate: String
    $attachments: String
    $note: String
  ) {
    createDocEntry(
      branch: $branch
      opType: $opType
      title: $title
      desc: $desc
      items: $items
      contractId: $contractId
      contractName: $contractName
      contractNameAr: $contractNameAr
      customerId: $customerId
      customerName: $customerName
      customerNameAr: $customerNameAr
      supplierId: $supplierId
      supplierName: $supplierName
      supplierNameAr: $supplierNameAr
      departmentId: $departmentId
      departmentName: $departmentName
      departmentNameAr: $departmentNameAr
      employeeId: $employeeId
      employeeName: $employeeName
      employeeNameAr: $employeeNameAr
      employeeColor: $employeeColor
      resourseId: $resourseId
      resourseName: $resourseName
      resourseNameAr: $resourseNameAr
      resourseColor: $resourseColor
      total: $total
      discount: $discount
      amount: $amount
      debit: $debit
      debitAcc: $debitAcc
      debitAccName: $debitAccName
      debitAccNameAr: $debitAccNameAr
      credit: $credit
      creditAcc: $creditAcc
      creditAccName: $creditAccName
      creditAccNameAr: $creditAccNameAr
      chequeBank: $chequeBank
      chequeNo: $chequeNo
      chequeDate: $chequeDate
      attachments: $attachments
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
